import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GodModeService {
  private _godModeUser = new BehaviorSubject<any>(null);
  godModeUser$ = this._godModeUser.asObservable();

  exitGodMode() {
    localStorage.removeItem('godModeUser');
    localStorage.removeItem('OriginalAccessToken');
    this._godModeUser.next(null);
  }

  get isActive(): boolean {
    return this._godModeUser.value !== null;
  }

  get currentUser(): any {
    return this._godModeUser.value;
  }

  enterGodMode(user: any) {
    return this._godModeUser.next(user);
  }
}
